import React from "react";
import { Routes, Route } from "react-router-dom";
import { Dash } from "../pages/admin/dash";

// All admin sub-routes are rendered inside the Dash layout (sidebar + topbar).
// The actual sub-route mapping lives in Dash.jsx via its internal <Routes>.
export const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/*" element={<Dash />} />
    </Routes>
  );
};
